import { APIStatus } from '@application/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { updateFamilyFestEventSpotsAsync } from './familyFestEventSpotsThunk';
export const initialState = {
    status: APIStatus.IDLE,
    eventSpots: null
};
export const familyFestEventSpotsState = createSlice({
    name: 'familyFestEventSpots',
    initialState,
    reducers: {
        resetEventSpotsStatus: (state) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateFamilyFestEventSpotsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateFamilyFestEventSpotsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.eventSpots = action.payload;
        })
            .addCase(updateFamilyFestEventSpotsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetEventSpotsStatus } = familyFestEventSpotsState.actions;
export default familyFestEventSpotsState.reducer;
